export const environment = {
  production: false,
  apiUrl: 'api',
  appName: 'Central Payment Portal',
  version: '1.0.0',
  environment: 'development'
};

